import clsx from "clsx";
import LoadingSpinnerInline from "../../../../components/common/loading-spinner/loading-spinner-inline";

interface CancelOrderConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  selectedOrderCount: number;
  isConfirmLoading: boolean;
}

const CancelOrderConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  isConfirmLoading,
  selectedOrderCount,
}: CancelOrderConfirmModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-40">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full mx-4">
        <h2 className="text-2xl font-bold mb-4">정말로 주문을 취소할까요?</h2>
        <p className="text-lg text-gray-600 mb-4">
          선택된 <span className="font-bold">{selectedOrderCount}개</span>의
          주문이 취소돼요!
        </p>
        <div className="flex justify-end gap-2">
          <button
            className="bg-gray-500 text-white px-4 py-2 rounded-lg"
            onClick={onClose}
          >
            취소
          </button>
          <button
            className={clsx(
              "bg-red-500 text-white px-4 py-2 rounded-lg",
              isConfirmLoading && "pointer-events-none opacity-80"
            )}
            onClick={onConfirm}
            disabled={isConfirmLoading}
          >
            {isConfirmLoading ? <LoadingSpinnerInline /> : "확인"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelOrderConfirmModal;
